import React, { useState, useEffect } from "react";
import axios from 'axios';
import params from "../config/Params";
import { useNavigate } from 'react-router-dom';
import { getItemFromLocalStorage } from '../utils/storageUtils';
import { useParams } from 'react-router-dom'; 
import { Helmet } from 'react-helmet';
import { toast } from 'react-toastify';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import Lottie from "lottie-react";
import doneAnimation from '../animation/done.json';
import rocketAnimation from '../animation/rocket.json';

const AccelerateListing = () => {
  const { listingId } = useParams();
  const [listing, setListing] = useState([]);
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [message, setMessage] = useState("");
  const [selectedViwOffer, setSelectedViwOffer] = useState(null);
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [confirmOfferId, setConfirmOfferId] = useState(null);
  const [activeIndex, setActiveIndex] = useState(null);
  const [mainOfferImage, setMainOfferImage] = useState('/assets/img/accelerate_offer_1.gif');
  const navigate = useNavigate();
  const [lottiePhase, setLottiePhase] = useState("idle");

  useEffect(() => {      
    const fetchListingData = async () => {
      const hostData = getItemFromLocalStorage('hostProfile');
      let formData = new FormData();
      formData.append('token', hostData.host_access_token);
      formData.append('listing_id', listingId);
  
      try {
        const response = await axios({
          method: 'post',
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          url: `${params.baseURL}${params.endpoints.getListingData}`,
          data: formData,
        });
  
        if (response.data.status === 'ok') {
          setListing(response.data.updated_property_item);
        } else {
          console.log('An error occurred while fetching data.');
        }
      } catch (err) {
        console.log(err.message);
      }
    };

    const fetchOffers = async () => {
        const hostData = getItemFromLocalStorage('hostProfile');
        let formData = new FormData();
        formData.append('token', hostData.host_access_token);
        formData.append('listing_id', listingId);

        try {
            const response = await axios({
                method: 'post',
                headers: {
                  'Content-Type': 'multipart/form-data'
                },
                url: `${params.baseURL}${params.endpoints.accOffers}`,
                data: formData
            });
        
            if (response.data.items && Array.isArray(response.data.items)) {
              const sortedOffers = [...response.data.items].sort((a, b) => {
                return b.offer_top - a.offer_top;
              });

              setOffers(response.data.items);

              if (sortedOffers.length > 0) {
                setMainOfferImage(sortedOffers[0].offer_icon);
                setSelectedViwOffer(sortedOffers[0]);
              }

              setLoading(false);
            } else {
                setError('An error occurred while fetching data.');
            }
        } catch (err) {
            setError(err);
            setLoading(false);
        }
    };

    fetchOffers();
    fetchListingData();
  }, []);

  const activateOffer = async (offerId) => {
    const hostData = getItemFromLocalStorage("hostProfile");
    let formData = new FormData();
    formData.append("token", hostData.host_access_token);
    formData.append('listing_id', listingId);
    formData.append("offer_id", offerId);

    try {
      const response = await axios.post(
        `${params.baseURL}${params.endpoints.activateOffer}`,
        formData
      );

      if (response.data.status === "ok") {
        setSelectedOffer(null);
        setTimeout(() => setLottiePhase("done"), 3000);
        setTimeout(() => {
          setShowConfirmPopup(false);
          setLottiePhase("idle");
          navigate("/accelerate-program/");
        }, 5000);
      } else {
        setMessage(response.data.message || "Failed to activate offer.");
        setLottiePhase("idle");
      }
    } catch (error) {
      setMessage("An error occurred while activating the offer.");
      setLottiePhase("idle");
      console.error(error);
    }
  };

  const handleOtherOfferClick = (offer) => {
    setMainOfferImage(offer.offer_icon);
    setSelectedViwOffer(offer);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

   const faqs = [
    {
        question: "What is Lorem Ipsum?",
        answer: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
    },
    {
        question: "Where does it come from?",
        answer: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old."
    },
  ];
  
  const toggleAccordion = (index) => {
      setActiveIndex(activeIndex === index ? null : index);
  };

  const getOfferPieData = (number) => {
    const mappings = {
      "10": [10, 90],
      "15": [25, 75],
      "20": [32, 68],
      "25": [40, 60],
      "30": [48, 52],
      "35": [55, 45],
      "40": [63, 37],
      "45": [70, 30],
      "50": [80, 20],
      "60": [95, 5],
    };

    const [wire, rest] = mappings[number?.toString()] || [0, 100];
    return [
      { name: `Wire Stay Guest ${wire}%`, value: wire },
      { name: `Rest Guest ${rest}%`, value: rest },
    ];
  };

  const COLORS = ['#2a62ff', '#fd9a00'];

  return (
    <div>
        <Helmet>
            <title>Accelerate!</title>
            <meta name='description' content='' />
        </Helmet>

        <div className="row">
          <div className="col-md-7">
            <div className="ap-offer-section">
              <div className="apoffbx">

                  <div className="acc-off-title-box" style={{margin: '0 14px'}}>
                    <h1>Accelerate - {listing.listing_title}</h1>
                  </div>

                  {offers.length > 0 ? (
                  <>
                    <div className='row rmofr-section' style={{marginBottom:'1rem', background:'transparent', boxShadow: 'rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px', margin: '0 14px'}}>
                      <div className='col-md-12 lb' key={selectedViwOffer?.p_offer_id}>
                        <div>
                          <div className="first-option">
                            <div className="first-option-box">
                              <div style={{display: 'flex', alignItems: 'center', flex: 1, padding:'20px', boxShadow: 'rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px'}}>
                                <img className="img-fluid aib-oimg" src={mainOfferImage} alt="Offer Icon" /> 
                              </div>

                              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', boxShadow: 'rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px', padding:'20px', flexWrap: 'wrap', flex: 1}}>
                                <div style={{ width: '150px', height: '150px', flex:1  }}>
                                  <ResponsiveContainer width="100%" height="100%">
                                    <PieChart margin={{ top: 0, right: 0, bottom: 0, left: 0 }}>
                                      <Pie
                                        data={getOfferPieData(selectedViwOffer?.offer_graph)}
                                        cx={'50%'}
                                        cy={'50%'}
                                        innerRadius="70%"
                                        outerRadius="100%"
                                        paddingAngle={0}
                                        dataKey="value"
                                      >
                                        {getOfferPieData(selectedViwOffer?.offer_graph).map((entry, index) => (
                                          <Cell key={`cell-${index}`} fill={COLORS[index]} />
                                        ))}
                                      </Pie>
                                    </PieChart>
                                  </ResponsiveContainer>
                                </div>

                                <div style={{ fontSize: '14px', flex:1 }}>
                                  {getOfferPieData(selectedViwOffer?.offer_graph).map((entry, index) => (
                                    <div key={index} style={{marginBottom: '8px' }}>
                                      <div><strong className="text-uppercase">{entry.name}</strong></div>
                                      <div style={{
                                        width: '100%',
                                        height: '4px',
                                        backgroundColor: COLORS[index],
                                      }} />
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>

                            <div className="act-off-bs">
                              <button className="btn btn-black" onClick={() => {
                                setConfirmOfferId(selectedViwOffer?.p_offer_id);
                                setShowConfirmPopup(true);
                              }}>
                                Boost!
                              </button>
                            </div>

                          </div>
                        </div>
                      </div>
                  </div>
                  <div className="row rmofr-section">
                      {offers.map((offer) => (
                        <div className='col-md-6 lb' key={offer.p_offer_id} onClick={() => handleOtherOfferClick(offer)}>
                          <div className="rmngoffer-bx">
                            <div className="other-option">
                              <img
                                className="img-fluid aib-oimg"
                                src={offer.offer_icon}
                                alt={'Wire stay offer icon'}
                              />
                            </div>
                            <hr></hr>
                            <div className="sofaofl-btn-box">
                              <button className="sofaofl-btn">Select</button>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </>
                  ) : (
                    <p>No offer found</p>
                  )}
              </div>
            </div>
          </div>
          
          <div className="col-md-1"></div>
          <div className='col-md-4 p-0'>
            <div className='bfhsd'>
                <div className='blog-box'>
                    <div class="blog">
                        <div class="blog-image">
                            <img src={'https://app.wirestay.com/ws/uploads/blog/1736870810_pi.jpg'} className='img-fluid' alt="" />
                            <div class="date">May 08, 2025</div>
                        </div>
                        <div class="blog-content">
                            <h2>What is Lorem Ipsum?</h2>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris vel metus vel est fermentum consectetur.</p>
                            <a href="#">Read More</a>
                        </div>
                    </div>
                </div>
                <div className="faq-sticky">
                    {faqs.map((faq, index) => (
                    <div key={index} className='faqs-list-section'>
                        <div
                        onClick={() => toggleAccordion(index)} className='faqs-qustn-box'
                        style={{
                            backgroundColor: activeIndex === index ? "#f7f7f7" : "#ffffff",
                        }}
                        >
                        {faq.question}
                        <i
                            className={`fas ${
                            activeIndex === index ? "fa-chevron-up" : "fa-chevron-down"
                            }`}
                            style={{
                            transition: "transform 0.3s ease",
                            }}
                        ></i>
                        </div>
                        {activeIndex === index && (
                        <div className='faqs-ans-box'>
                            {faq.answer}
                        </div>
                        )}
                    </div>
                    ))}
                </div>
            </div>
        </div>

        </div>

        {showConfirmPopup && (
          <div className="confirmation-popup-overlay">
            <div className="confirmation-popup" style={{ position: 'relative', width: '600px', height:'475px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center' }}>
              
              {lottiePhase === "idle" && (
                <div className="euc-close" onClick={() => setShowConfirmPopup(false)} style={{ alignSelf: 'flex-end' }}>
                  <img src={'/assets/img/icons/popup_close.png'} className="img-fluid" alt="" style={{width:'35px'}} />
                </div>
              )}

              {lottiePhase !== "idle" ? (
                <Lottie
                  animationData={lottiePhase === "rocket" ? rocketAnimation : doneAnimation}
                  loop={false}
                  style={{ height: 450, width: 300 }}
                />
              ) : (
                <>
                  <div className="aclpaob">
                    <img src={'/assets/img/banners/accelerate_pop_banner_2.png'} className="img-fluid" alt=""/>
                    <div className="aclp-txt">
                      <p className="mb-0">Do you really want to accelerate this offer</p>
                    </div>
                    <div className="popup-actions w-100">
                      <button
                        className="btn btn-black rounded-0 w-100"
                        style={{fontFamily: 'KenyanCoffee', fontSize: '20px'}}
                        onClick={async () => {
                          setLottiePhase("rocket");
                          await activateOffer(confirmOfferId);
                        }}
                      >
                        Yes I Want
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        )}

    </div>
  );
};

export default AccelerateListing;
